import { RequestsApi } from '../RequestsApi';

class PaymentApi extends RequestsApi {
    async getPlansList() {
        return await this.request('/payment/plan', 'get');
    }

    async getProductsList() {
        return await this.request('/payment/product', 'get');
    }

    async createOfferForUserByPlan(planId) {
        return await this.request(`/payment/plan/${planId}/offer`, 'post');
    }

    async getPaymentsHistory(page) {
        return await this.request(`/payment/history?page=${page}`, 'get');
    }

    // HORO-10538. Returns `{ method: null }` for an account with no card on
    // file, which is a normal answer rather than an error — see the reducer.
    async getPaymentMethod() {
        return await this.request('/payment/method', 'get');
    }

    async createPaymentTrial(params) {
        // add session devise id here
        return await this.request(`/payment/token/trial`, 'post', params);
    }

    async createPaymentPlan(id, data) {
        // add session devise id here
        return await this.request(`/payment/token/subscription/${id}`, 'post', data);
    }

    async createPaymentProduct(id, data) {
        return await this.request(`/payment/token/product/${id}`, 'post', data);
    }

    async createSessionTrial(params) {
        return await this.request(`/payment/session/trial`, 'post', params);
    }

    async createSessionPlan(id, data) {
        return await this.request(`/payment/session/subscription/${id}`, 'post', data);
    }

    async createSessionProduct(id, data) {
        return await this.request(`/payment/session/product/${id}`, 'post', data);
    }

    async createGooglePayToken(data) {
        return await this.request(`/payment/google-pay/token`, 'post', data);
    }

    async cancelSubscription() {
        return await this.request(`/payment/subscription/cancel`, 'post');
    }

    // HORO-10539: deferred plan switching. Preview and change are separate
    // calls so the customer sees the figures before committing; the change
    // recomputes them server-side rather than trusting what preview returned.
    async previewPlanSwitch(planId) {
        return await this.request(`/payment/subscription/switch/preview/${planId}`, 'get');
    }

    async schedulePlanSwitch(planId) {
        return await this.request(`/payment/subscription/switch/${planId}`, 'post');
    }

    async cancelPendingPlanSwitch() {
        return await this.request(`/payment/subscription/switch/cancel`, 'post');
    }
    // HORO-10545: deliberately its own endpoint rather than a body on the
    // cancel/delete calls. It serves both surveys, it is best-effort, and the
    // deletion case has to write before the account goes away.
    async submitFeedbackSurvey(data) {
        return await this.request(`/feedback-survey`, 'post', data);
    }
    async validationAppleSession(data) {
        return await this.request(`/payment/apple-pay/validate`, 'post', data);
    }
    async createApplePayToken(data) {
        return await this.request(`/payment/apple-pay/token`, 'post', data);
    }
}

export default new PaymentApi();
